import { Link, useLocation } from "react-router-dom";

export default function Taskbar() {
  const location = useLocation();
  
  const isActive = (path) => location.pathname === path;

  // Hide admin from taskbar - it's now accessed from homepage footer
  if (location.pathname === '/admin') {
    return null;
  }

  return (
    <nav className="myspace-nav fixed top-0 left-0 right-0 z-50" data-testid="taskbar">
      <div className="max-w-[1000px] mx-auto flex items-center justify-between">
        {/* Logo / Home button */}
        <Link 
          to="/" 
          className="flex items-center px-3 py-1"
          data-testid="nav-home-logo"
        >
          <img 
            src="/favicon.gif" 
            alt="kezzio :)" 
            className="h-8"
          />
        </Link>

        {/* Navigation links - no Admin here */}
        <ul className="flex m-0 p-0 list-none">
          <li className="border-r border-[#1a4a7a]">
            <Link 
              to="/discography" 
              className={`block px-4 py-2 text-white no-underline text-[11px] font-bold uppercase ${isActive('/discography') ? 'bg-[#1a4a7a] text-[#00ddff]' : 'hover:bg-[#1a4a7a]'}`}
              data-testid="nav-discography"
            >
              Discography
            </Link>
          </li>
          <li className="border-r border-[#1a4a7a]">
            <Link 
              to="/videos" 
              className={`block px-4 py-2 text-white no-underline text-[11px] font-bold uppercase ${isActive('/videos') ? 'bg-[#1a4a7a] text-[#00ddff]' : 'hover:bg-[#1a4a7a]'}`}
              data-testid="nav-videos"
            >
              Videos
            </Link>
          </li>
          <li className="border-r border-[#1a4a7a]">
            <Link 
              to="/photos" 
              className={`block px-4 py-2 text-white no-underline text-[11px] font-bold uppercase ${isActive('/photos') ? 'bg-[#1a4a7a] text-[#00ddff]' : 'hover:bg-[#1a4a7a]'}`}
              data-testid="nav-photos"
            >
              Photos
            </Link>
          </li>
          <li className="border-r border-[#1a4a7a]">
            <Link 
              to="/blog" 
              className={`block px-4 py-2 text-white no-underline text-[11px] font-bold uppercase ${isActive('/blog') ? 'bg-[#1a4a7a] text-[#00ddff]' : 'hover:bg-[#1a4a7a]'}`}
              data-testid="nav-blog"
            >
              Blog
            </Link>
          </li>
          <li>
            <Link 
              to="/about" 
              className={`block px-4 py-2 text-white no-underline text-[11px] font-bold uppercase ${isActive('/about') ? 'bg-[#1a4a7a] text-[#00ddff]' : 'hover:bg-[#1a4a7a]'}`}
              data-testid="nav-about"
            >
              About
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
